<template>
  <Modal
    v-model="_value"
    width="800"
    ok-text="添加"
    cancel-text=""
    @on-ok="onOk"
    @on-visible-change="visibleChange"
    title="添加两客一危一重客户参数">
    <Form ref="setupRegistration" autoComplete="on" class="card-box login-form" :label-width="120">
      <Form-item label="客户名称">
        <Input v-model="gdDlysjgClientParam.clientName"></Input>
      </Form-item>
      <Form-item label="账户类型">
        <Select v-model="gdDlysjgClientParam.accountType" style="width:300px; margin-right: 10px;">
          <Option v-for="item in accountTypeList" :value="item.value" :key="item.label">{{ item.label }}</Option>
        </Select>
      </Form-item>
      <Form-item label="授权码">
      <Input v-model="gdDlysjgClientParam.authorizationCode"></Input>
      </Form-item>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  export default {
    name: 'addgddlysjgclientparammodal',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {

        accountTypeList:[
          {label: '客户账号', value: 1},
          {label: '三方监控中心', value: 2}],

        gdDlysjgClientParam: {
          clientName: null,
          authorizationCode:null,
          accountType:1
        }
      }
    },
    methods: {
      ...mapActions([
        'GdDlysjgClientParamServ_AddObj'
      ]),
      onOk () {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认添加</p>',
          onOk: () => {
            store.dispatch('GdDlysjgClientParamServ_AddObj', {
              params: this.gdDlysjgClientParam
            }).then(() => {
              this.$Message.success('添加成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
            })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange (val) {
        if (val) {
        }
      }
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
